import { Utils } from '@/utils/Utils'

// [양식 다운로드] 업로드 파서(BE)와 1:1 정합되는 실제 엑셀 양식을 그대로 내려준다.
// (가이드행 + 헤더(3행: 국가/물류카테고리/서비스 항목/주문유형/단가/시작일/종료일) + 코드표 드롭다운 포함)
// CSV 자체 생성 방식은 BE 업로드 파서(xlsx, 헤더 3행)와 어긋나 재업로드가 실패하므로 폐기.
const TEMPLATE_FILE = 'MFS_카테고리단가_업로드양식.xlsx'

export const downloadCategoryPriceTemplate = () => {
  const a = document.createElement('a')
  a.href = Utils.assetUrl(TEMPLATE_FILE)
  a.download = TEMPLATE_FILE
  a.click()
}
